module.exports = __webpack_public_path__ + "img/bot_bdd.b5747528.jpg";